import React from 'react';
import { compose, withHandlers, lifecycle, withState } from 'recompose';
import { reduxForm, Field } from 'redux-form';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Select from 'react-select';
import Grid from '@material-ui/core/Grid';
import { get, sortBy } from 'lodash';
import { updateReservation } from './_api';
import withLoader from '../app/withLoader';
import { users as getAllUsers } from './../users/_api';

const enhance = compose(
  withLoader,
  withState('users', 'setUsers', null),
  lifecycle({
    async componentDidMount() {
      const { toggleLoader, setUsers } = this.props;
      toggleLoader();
      const users = await getAllUsers();
      setUsers(get(users, 'items', []));
      toggleLoader(false);
    },
  }),
  withHandlers({
    onSubmit: ({ item, setEditUserDialog, loadItem, toggleLoader }) => async values => {
      toggleLoader();
      const resp = await updateReservation(item.id, { userId: get(values, 'userId.value', 0) });
      if (resp) {
        setEditUserDialog(false);
        await loadItem(item.id);
      }
      toggleLoader(false);
    },
  }),
  reduxForm({ form: 'editItem' }),
);

export default enhance(({
    editUserDialog, setEditUserDialog, fullScreen, handleSubmit, users
}) => (
  <form onSubmit={handleSubmit}>
    <Dialog
      fullScreen={fullScreen}
      open={editUserDialog.open}
      onClose={() => setEditUserDialog({ open: false, title: '' })}
      aria-labelledby="responsive-dialog-title"
      maxWidth="sm"
      fullWidth={true}
    >
      <DialogTitle id="responsive-dialog-title">Úprava zákazníka rezervace</DialogTitle>
      <DialogContent>
        <Grid container={true} spacing={16}>
          <Grid item={true} xs={6} md={6} lg={6}>
            <div style={{ minHeight: 350 }}>
              <Field
                name="userId"
                component={props => (
                  <Select
                    value={props.input.value}
                    onChange={props.input.onChange}
                    onBlur={() => props.input.onBlur(props.input.value)}
                    options={sortBy(users, ['name']).map(item => ({
                      value: item.id,
                      label: `${item.name} (${item.phone})`,
                    }))}
                    placeholder="Select"
                    simpleValue
                    isDisabled={!users || users.length === 0}
                  />
                )}
              />
            </div>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button type="submit" color="primary" variant="contained" onClick={handleSubmit} autoFocus>
          Uložit
        </Button>
        <Button
          onClick={() => setEditUserDialog({ open: false, title: '' })}
          color="secondary"
          variant="contained"
        >
          Zrušit
        </Button>
      </DialogActions>
    </Dialog>
  </form>
));



// WEBPACK FOOTER //
// ./src/modules/reservations/editUserDialog.js